export default {
      id: "icon-P_ACTION-usage",
      viewBox: "0 0 28 32",
      url: "/" + "assets/sprite.svg#icon-P_ACTION",
      toString: function () {
        return this.url;
      }
    }